<template>
    <select style="width: 100%">
        <slot></slot>
    </select>
</template>
<script>
    export default {
        name: 'select2',
        props: ['options', 'value'],
        data() {
            return {
                isChanging: false
            }
        },
        mounted: function () {
            var vm = this;

            $(this.$el).parent().addClass('select2-parent');
            $(this.$el)
                // init select2
                .select2(this.getSelect2Options(this.options))
                .val(this.value)
                .trigger('change')
                // emit event on change.
                .on('change', function () {
                    if (!vm.isChanging) {
                        vm.isChanging = true;
                        var val = $(this).val();
                        vm.$emit('input', val)

                        if (!val) {
                            if (this.hasAttribute('multiple')) {
                                vm.$emit('update:selectedOptions', []);
                            } else {
                                vm.$emit('update:selectedOptions', null);

                            }
                        } else if (val instanceof Array) {
                            var selectedOptions = vm.options.filter(x => val.indexOf(x.id) != -1);
                            vm.$emit('update:selectedOptions', selectedOptions);
                        } else {
                            var selectedOption = vm.options.find(x => x.id == val);
                            vm.$emit('update:selectedOptions', selectedOption);
                        }

                        vm.$nextTick(function () {
                            vm.isChanging = false;
                        });
                    }

                    if ($(this).val()) {
                        var selected = $(this).val().length;
                        if (selected > 1) {
                            var of = $(this).find('option').length;

                            if (selected == of) {
                                $(this).parent().find('.select2 .select2-selection ul li').remove('li');
                                $(this).parent().find('.select2 .select2-selection ul').append('<span style="line-height: 27px">--- Tất cả ---</span>')
                            } else if (selected > 10) {
                                $(this).parent().find('.select2 .select2-selection ul li').remove('li');
                                $(this).parent().find('.select2 .select2-selection ul').append('<span style="line-height: 27px">Đã chọn ' + selected + ' / ' + of + '  bản ghi.</span>')
                            }
                        }
                    }
                })
        },
        methods: {
            getSelect2Options(data) {
                var modalContent = $(this.$el).closest('.modal-content');
                return {
                    data: data,
                    closeOnSelect: !this.$el.hasAttribute('multiple'),
                    allowClear: this.$el.hasAttribute('allowClear'),
                    placeholder: this.$el.getAttribute('placeholder'),
                    dropdownParent: modalContent.length > 0 ? modalContent : null
                };
            }
        },
        watch: {
            value: function (value) {
                // update value
                if (!this.isChanging) {
                    this.isChanging = true;
                    $(this.$el)
                        .val(value)
                        .trigger('change');
                    this.isChanging = false;
                }
            },
            options: function (options) {
                // update options
                var val = $(this.$el).val();
                $(this.$el).empty().select2(this.getSelect2Options(options));
                if (options && options.length > 0 && options.find(x => x.id == val) != null) {
                    $(this.$el).val(val).trigger('change');
                } else {
                    $(this.$el).val(null).trigger('change');

                }
            }
        },
        destroyed: function () {
            $(this.$el).off().select2('destroy')
        }
    }
</script>

